import { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DanhSachPhieu from '../../../component/DanhSachPhieu';
import LabelRequired from '../../../component/LabelRequired';
import { MAP_EXPORT_PATH } from '../../../component/button-in-phieu/constant';
import { inPhieuVienPhi } from '../../../phan-he-vien-phi/services/PhanHeVienPhiServices';
import { usePhanHeBaoHiemYTeContext } from '../../contexts';
import { getInsuranceInvoiceDetail, getInsuranceInvoices } from '../../services';
import { APP_DATE_FORMAT, CODE } from '../../../utils/Constant';
import { formatDateTime, formatMoney } from '../../../utils/FormatUtils';
import moment from 'moment';
import { AppContext } from '../../../appContext/AppContext';

const CellInfo = ({
	label,
	value,
	colSpan = 4,
}: {
	label: string;
	value?: string;
	colSpan?: number;
}) => {
	return (
		<Col xs={colSpan} className="d-flex align-items-center text-lable-input mb-3">
			<LabelRequired label={label} className="spaces min-w-110" />
			<span className="fw-400 text-truncate">{value ?? '...'}</span>
		</Col>
	);
};

const PaymentInfo = () => {
	const { patientInfo } = usePhanHeBaoHiemYTeContext();
	const { setIsLoading } = useContext(AppContext);

	const [invoices, setInvoices] = useState([]);
	const [invoiceInfo, setInvoiceInfo] = useState<any>({});

	useEffect(() => {
		if (patientInfo?.visitCode) {
			getInvoices(patientInfo?.visitCode);
			setInvoiceInfo({});
		}
	}, [patientInfo?.visitCode]);

	const getInvoices = async (visitCode: string) => {
		try {
			const { data, code } = await getInsuranceInvoices(visitCode);
			if (CODE.SUCCESS === code) {
				setInvoices(
					data.map((item: any) => ({
						...item,
						date: formatDateTime(item?.invDate, APP_DATE_FORMAT),
						price: `${item?.display} ${formatMoney(item?.invTotal)}`,
					}))
				);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleGetParams = (itemPrint: any) => {
		return {
			id: itemPrint?.id,
			invoiceType: MAP_EXPORT_PATH[itemPrint?.invTypeCode],
		};
	};

	const onInvoiceSelect = async (invoice: any) => {
		try {
			setIsLoading(true);
			const { data } = await getInsuranceInvoiceDetail(invoice.id);
			setInvoiceInfo(data);
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};

	const formatAddressInfo = (data: any) => {
		return (
			[data?.ptAddress, data?.ptCommuneName, data?.ptDistrictName, data?.ptProvinceName]
				.filter((item) => item)
				.join(', ') || undefined
		);
	};

	return (
		<div>
			<DanhSachPhieu
				dsPhieu={invoices}
				handleSelectRowData={onInvoiceSelect}
				title="price"
				handleGetParams={handleGetParams}
			/>

			<div className="px-3 py-1 bg-white border-bottom border-top">
				<Row>
					<CellInfo colSpan={3} label="Khoa phòng:" value={invoiceInfo?.visitDeptName} />
					<CellInfo
						colSpan={3}
						label="Đối tượng:"
						value={invoiceInfo?.visitObjectTypeName}
					/>
					<CellInfo
						colSpan={6}
						label="Nơi sống:"
						value={formatAddressInfo(invoiceInfo)}
					/>
				</Row>

				<Row>
					<CellInfo
						colSpan={3}
						label="Ngày vào viện:"
						value={formatDateTime(invoiceInfo?.visitStartedDate)}
					/>
					<CellInfo
						colSpan={3}
						label="Ngày ra viện:"
						value={formatDateTime(invoiceInfo?.visitStoppedDate)}
					/>
					<CellInfo
						colSpan={3}
						label="Số ngày điều trị:"
						value={invoiceInfo?.visitLengthOfStay}
					/>
				</Row>

				<Row>
					<CellInfo colSpan={3} label="Số BHYT:" value={invoiceInfo?.insCode} />
					<CellInfo
						colSpan={3}
						label="Hạn thẻ:"
						value={
							invoiceInfo?.insTo
								? moment(invoiceInfo?.insTo, 'YYYY-MM-DD').format(APP_DATE_FORMAT)
								: undefined
						}
					/>
					<CellInfo colSpan={3} label="Tuyến BHYT:" value={invoiceInfo?.examLevelName} />
					<CellInfo colSpan={3} label="Nơi KCBBĐ:" value={invoiceInfo?.insKcbbdName} />
				</Row>

				<Row>
					<CellInfo colSpan={3} label="Số phiếu:" value={invoiceInfo?.invCode} />
					<CellInfo colSpan={3} label="Loại phiếu:" value={invoiceInfo?.invTypeName} />
					<CellInfo colSpan={3} label="Người thu:" value={invoiceInfo?.invCashier} />
					<CellInfo
						colSpan={3}
						label="Ngày thu:"
						value={formatDateTime(invoiceInfo?.invDate)}
					/>
				</Row>

				<Row>
					<CellInfo
						colSpan={3}
						label="Số tiền:"
						value={
							invoiceInfo?.invTotal >= 0
								? formatMoney(invoiceInfo?.invTotal).toString()
								: undefined
						}
					/>
					<CellInfo colSpan={9} label="Ghi chú:" value={invoiceInfo?.invRemark} />
				</Row>
			</div>
		</div>
	);
};

export default PaymentInfo;
